import { useQuery } from 'react-query';
import { TemplateType } from 'types/narrative/narrative.types';

import { getTemplateByKey as queryFn } from 'api/endPoints/getTemplateByKey';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetTemplateByKey = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getTemplateByKey', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.componentKey) && Boolean(params.componentId),
    });
};

export interface QueryParams {
    componentKey: string | undefined;
    componentId: number | undefined | null;
}

export type GetTemplateByKeyRequestBody = QueryParams & {
    forCurrentCustomerOnly: boolean;
};

export interface Placeholder {
    id: number;
    name: string;
    section: string;
    description: string;
}

interface QueryResponse {
    componentKey: string;
    id: number;
    placeholders: Placeholder[];
    text: string | null;
    aiText: string | null;
    templateType: TemplateType;
}
